import { AssetIdSchema as C, CreativeGroupIdSchema as R } from "@hprofits/shared";
import { PrivilegeEnum as e } from "@hprofits/shared/auth";
import { z as s } from "zod";
import "../common/acl-view.js";
import { ocPrivate as t } from "../common/auth/procedure-builders.js";
import { createCreationResultSchema as c } from "../common/creation-result.js";
import "../common/owner.js";
import { CampaignGroupIdParamSchema as d, CreativeGroupIdParamSchema as i, LandingGroupIdParamSchema as g, LandingIdParamSchema as h, CreativeIdParamSchema as v, ForceActionParamSchema as l, AssetIdParamSchema as p } from "../common/params.js";
import "../common/errors/constants.js";
import { alreadyExistsError as o, inUseError as n, notFoundError as r, expectationFailedError as u } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as a } from "../swagger/tags.js";
import { CreateCreativeGroupCommonSchema as G, CreateCreativeGroupAdminSchema as A, UpdateCreativeGroupCommonSchema as I, UpdateCreativeGroupAdminSchema as f, CreateAdvertLabelSchema as T, AdvertLabelSchema as y, AdvertLabelListSchema as P, LandingGroupUpdateBaseSchema as w, validateLandingGroupRates as L, LandingGroupListItemSchema as S, LandingGroupCreateSchema as U, LandingGroupListQuerySchema as O, LandingGroupListSchema as b, LandingUpdateSchema as V, LandingListItemSchema as E, LandingCreateSchema as _, LandingListQuerySchema as W, LandingListSchema as x, CreativeUpdateSchema as D, CreativeListItemSchema as m, CreativeCustomContentCreateSchema as j, CreativeCreateSchema as z, CreativeListQuerySchema as F, CreativeListSchema as Q, CreativeRejectReasonsDictionarySchema as q, CreativeReviewSchema as H, LandingRejectReasonsDictionarySchema as M, LandingReviewSchema as k, UpdateAssetSchema as B, AssetViewSchema as J, CreateAssetSchema as K, RenameCreativeGroupSchema as N, CreativeGroupViewSchema as X, CreativeGroupListSchema as Y } from "./schemas.js";
const Z = s.union([
  G.unwrap().extend({
    campaignId: d.shape.campaignId
  }),
  A.unwrap().extend({
    campaignId: d.shape.campaignId
  })
]), $ = s.union([
  I.unwrap().extend({
    creativeGroupId: i.shape.creativeGroupId
  }),
  f.unwrap().extend({
    creativeGroupId: i.shape.creativeGroupId
  })
]), he = {
  creativeGroup: {
    /**
     * Get all creative groups for a campaign
     */
    findAll: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/campaigns/{campaignId}/creative-groups",
      summary: "Get all creative groups for a campaign",
      tags: [a.CREATIVE_GROUPS.name]
    }).input(d).output(Y).errors({
      ...r("Campaign not found")
    }),
    /**
     * Create a new creative group for a campaign
     */
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/campaigns/{campaignId}/creative-groups",
      summary: "Create a creative group for a campaign",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(Z).output(c(R)).errors({
      ...r("Ad type or format not found"),
      ...u("Referenced type/format entity in body not found or mismatched"),
      ...o("Creative group with this name already exists")
    }),
    /**
     * Get a creative group by ID
     */
    findOne: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/creative-groups/{creativeGroupId}",
      summary: "Get a creative group by ID",
      tags: [a.CREATIVE_GROUPS.name]
    }).input(i).output(X).errors({
      ...r("Creative group not found")
    }),
    /**
     * Update a creative group
     */
    update: t([e.WriteAdvert]).route({
      method: "PUT",
      path: "/creative-groups/{creativeGroupId}",
      summary: "Update a creative group",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input($).output(s.void()).errors({
      ...r("Creative group or referenced type/format not found"),
      ...u("Referenced type/format entity in body not found or mismatched")
    }),
    /**
     * Rename a creative group
     */
    rename: t([e.WriteAdvert]).route({
      method: "PATCH",
      path: "/creative-groups/{creativeGroupId}",
      summary: "Rename a creative group",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(
      N.unwrap().extend({
        creativeGroupId: i.shape.creativeGroupId
      })
    ).output(s.void()).errors({
      ...r("Creative group not found"),
      ...o("Creative group with this name already exists")
    }),
    /**
     * Delete a creative group
     */
    remove: t([e.WriteAdvert]).route({
      method: "DELETE",
      path: "/creative-groups/{creativeGroupId}",
      summary: "Delete a creative group",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(i).output(s.void()).errors({
      ...r("Creative group not found"),
      ...n("Creative group is used in ad groups")
    })
  },
  asset: {
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/campaigns/{campaignId}/creative-groups/{creativeGroupId}/assets",
      summary: "Add an asset into a creative group.",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(
      K.unwrap().extend({
        campaignId: d.shape.campaignId,
        creativeGroupId: i.shape.creativeGroupId
      })
    ).output(c(C)).errors({
      ...r("Landing or creative not found"),
      ...o("Duplicate asset")
    }),
    read: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/assets/{assetId}",
      summary: "Read an asset.",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 200
    }).input(p).output(J).errors({
      ...r("Asset not found")
    }),
    update: t([e.WriteAdvert]).route({
      method: "PUT",
      path: "/assets/{assetId}",
      summary: "Modify an asset.",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204,
      inputStructure: "detailed"
    }).input(
      s.object({
        params: p,
        query: l,
        body: B
      })
    ).output(s.void()).errors({
      ...r("Landing or creative not found"),
      ...o("Duplicate asset"),
      ...n("Asset is in use and cannot be modified")
    }),
    remove: t([e.WriteAdvert]).route({
      method: "DELETE",
      path: "/assets/{assetId}",
      summary: "Remove an asset from a creative group.",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204,
      inputStructure: "detailed"
    }).input(
      s.object({
        params: p,
        query: l
      })
    ).output(s.void()).errors({
      ...r("Asset not found"),
      ...n("Asset is in use and cannot be deleted")
    })
  },
  review: {
    landings: {
      review: t([e.WriteAdmin]).route({
        method: "POST",
        path: "/review/landings",
        summary: "Implement landings review process.",
        tags: [a.CREATIVE_GROUPS.name],
        successStatus: 204
      }).input(k.unwrap()).output(s.void()).errors({}),
      rejectReasons: t([e.WriteAdmin]).route({
        method: "GET",
        path: "/review/landings/dictionary/reject-reasons",
        summary: "Return recognizable reject reasons for landings.",
        tags: [a.CREATIVE_GROUPS.name],
        successStatus: 200
      }).output(M).errors({})
    },
    creatives: {
      review: t([e.WriteAdmin]).route({
        method: "POST",
        path: "/review/creatives",
        summary: "Implement creatives review process.",
        tags: [a.CREATIVE_GROUPS.name],
        successStatus: 204
      }).input(H.unwrap()).output(s.void()).errors({}),
      rejectReasons: t([e.WriteAdmin]).route({
        method: "GET",
        path: "/review/creatives/dictionary/reject-reasons",
        summary: "Return recognizable reject reasons for creatives.",
        tags: [a.CREATIVE_GROUPS.name],
        successStatus: 200
      }).output(q).errors({})
    }
  },
  creatives: {
    list: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/creatives",
      summary: "Get all creatives available for a user",
      tags: [a.CREATIVE_GROUPS.name]
    }).input(F).output(Q).errors({}),
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/creatives",
      summary: "Upload a creative file (multipart form data) for the caller or, by an admin, for another owner",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(z.unwrap()).output(m).errors({
      ...r("Owner, ad type, ad tag or label not found"),
      ...u("The file is not accepted for the ad type")
    }),
    createCustomContent: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/creatives/custom-content",
      summary: "Create a creative that carries HTML, VAST or an address instead of a file",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(j.unwrap()).output(m).errors({
      ...r("Owner, ad tag, label or banner size not found"),
      ...u("The ad type takes no creative")
    }),
    update: t([e.WriteAdvert]).route({
      method: "PUT",
      path: "/creatives/{creativeId}",
      summary: "Update the texts, ad tags, labels and custom content of a creative",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 200
    }).input(D.unwrap().extend(v.shape)).output(m).errors({
      ...r("Creative, ad tag or label not found"),
      ...u("The texts or the content are not accepted for the creative")
    }),
    remove: t([e.WriteAdvert]).route({
      method: "DELETE",
      path: "/creatives/{creativeId}",
      summary: "Delete a creative that no creative group or campaign uses",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(v).output(s.void()).errors({
      ...r("Creative not found"),
      ...n("Creative is used in creative groups or campaigns")
    })
  },
  landings: {
    list: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/landings",
      summary: "Get all landings available for a user",
      tags: [a.CREATIVE_GROUPS.name]
    }).input(W).output(x).errors({}),
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/landings",
      summary: "Create a landing in a new landing group",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(_.unwrap()).output(E).errors({
      ...r("Owner, ad tag or label not found"),
      ...o("Landing group with this name already exists for the owner")
    }),
    update: t([e.WriteAdvert]).route({
      method: "PUT",
      path: "/landings/{landingId}",
      summary: "Update the url, ad tags and labels of a landing",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 200
    }).input(V.unwrap().extend(h.shape)).output(E).errors({
      ...r("Landing, ad tag or label not found")
    }),
    remove: t([e.WriteAdvert]).route({
      method: "DELETE",
      path: "/landings/{landingId}",
      summary: "Delete a landing, and its group when it was the last landing there",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(h).output(s.void()).errors({
      ...r("Landing not found"),
      ...n("Landing group is used in creative groups or campaigns")
    })
  },
  landingGroups: {
    list: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/landing-groups",
      summary: "Get all landing groups available for a user, with their landings",
      tags: [a.CREATIVE_GROUPS.name]
    }).input(O).output(b).errors({}),
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/landing-groups",
      summary: "Create a landing group with one or more landings",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(U.unwrap()).output(S).errors({
      ...r("Owner or ad tag not found"),
      ...o("Landing group with this name already exists for the owner")
    }),
    update: t([e.WriteAdvert]).route({
      method: "PUT",
      path: "/landing-groups/{landingGroupId}",
      summary: "Replace the name, algorithm and landings of a landing group",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 200
    }).input(
      w.extend(g.shape).superRefine(L)
    ).output(S).errors({
      ...r("Landing group, landing or ad tag not found"),
      ...o("Landing group with this name already exists for the owner")
    }),
    remove: t([e.WriteAdvert]).route({
      method: "DELETE",
      path: "/landing-groups/{landingGroupId}",
      summary: "Delete a landing group and its landings",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 204
    }).input(g).output(s.void()).errors({
      ...r("Landing group not found"),
      ...n("Landing group is used in creative groups or campaigns")
    })
  },
  advertLabels: {
    list: t([e.ReadAdvert]).route({
      method: "GET",
      path: "/advert-labels",
      summary: "List the caller's labels for creatives and landings",
      tags: [a.CREATIVE_GROUPS.name]
    }).output(P).errors({}),
    create: t([e.WriteAdvert]).route({
      method: "POST",
      path: "/advert-labels",
      summary: "Create a label owned by the caller",
      tags: [a.CREATIVE_GROUPS.name],
      successStatus: 201
    }).input(T).output(y).errors({
      ...o("The caller already has a label with this name")
    })
  }
};
export {
  he as creativeGroupContract
};
//# sourceMappingURL=contract.js.map
